import {
  DeleteTaskFileDocument,
  DeleteTaskFileMutationVariables,
  GetTaskFilesDocument,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

export const useDeleteTaskFile = () => {
  const [deleteTaskFile, { loading }] = useMutation(DeleteTaskFileDocument, {
    extractorFn: (data) => data.tasksMutations.deleteTasksTaskFile,
    refetchQueries: [GetTaskFilesDocument],
  })

  return {
    deleteTaskFile: (variables: DeleteTaskFileMutationVariables) => {
      return deleteTaskFile({
        variables,
      })
    },
    loading,
  }
}
